import React, {
  Fragment,
  useState,
  useEffect,
  useRef,
  useCallback,
} from "react";
import { sounds } from "../../helpers/constants";

const AllAudio = ({ setAudioToSoundMap }) => {
  const [audioInitialized, setAudioInitialized] = useState(false);
  const audioInitializedRef = useRef(false);
  const audioToSoundMapRef = useRef({});

  useEffect(() => {
    audioInitializedRef.current = audioInitialized;
  }, [audioInitialized]);

  const unlockAudio = useCallback(
    (e) => {
      e.preventDefault();
      setTimeout(() => {
        if (audioInitializedRef.current) {
          return;
        }

        Object.keys(audioToSoundMapRef.current).forEach((soundName) => {
          const audio = audioToSoundMapRef.current[soundName];
          audio.volume = 0;
          audio.play();
          audio.pause();
          audio.volume = 1;
          audio.currentTime = 0;
        });

        setAudioToSoundMap(audioToSoundMapRef.current);
        audioInitializedRef.current = true;
        setAudioInitialized(true);
        document.removeEventListener("click", unlockAudio);
      }, 0);
    },
    [setAudioToSoundMap]
  );

  useEffect(() => {
    audioToSoundMapRef.current = {
      [sounds.CALL]: null,
      [sounds.CHECK]: null,
      [sounds.DING]: null,
      [sounds.FOLD]: null,
      [sounds.RAISE]: null,
      [sounds.WIN]: null,
    };

    Object.keys(audioToSoundMapRef.current).forEach((soundName) => {
      audioToSoundMapRef.current[soundName] = new Audio(
        `${process.env.PUBLIC_URL}/assets/sounds/${soundName}.mp3`
      );
    });

    // the first time the user does an interaction, "mount/unlock" the audio
    // to get around the fact that certain browsers require user interaction
    // to auto-play audio
    document.addEventListener("click", unlockAudio);

    return () => {
      document.removeEventListener("click", unlockAudio);
    };
  }, [unlockAudio]);

  return <Fragment />;
};

export default AllAudio;
